import React from 'react';

export default props => <p className="h4">Loading...</p>;



// WEBPACK FOOTER //
// ./src/components/Loading.js